module.exports = __webpack_public_path__ + "media/images/booking-a2ad0d20cd15082ad14cb720c87ed3a8.png";